import { Capacitor } from '@capacitor/core'
import { useStorage } from '@vueuse/core'
import { boot } from 'quasar/wrappers'
import { useStore } from '../store'
import { AuthenticationModel } from '../models/Authentication'
import { useAuthenticateSAML } from '../store/useAuthenticateSAML'
import { bootErrorMessage } from './error/bootErrorMessage'
import { clearQueue } from './loader/loader'
import { Token_JWT } from '../types/components/data-rendering'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async (/* { app, router, ... } */) => {
  try {
    //if switch_to, avoid checking out previous JWT
    //current route would be /#/login?switch_to=true...etc
    const route = window.location.href
    const switchTo = route.split('?').find((fragment) => fragment.includes('switch_to='))
    if (typeof switchTo !== 'undefined') {
      return void 0
    }

    const { loadJWT } = AuthenticationModel()
    const { setJWT, setSamlID } = useAuthenticateSAML()
    const store = useStore()
    //load JWT if present
    await loadJWT().then(async (jwt) => {
      const saml_request = useStorage<null | any>('saml_request', {})
      console.log(saml_request.value)
      if (!jwt) {
        // for browsers, check if saml_request is in local_storage
        // if it is there, we set saml id, which will trigger a fetch,
        // and grab a jwt.
        if (!Capacitor.isNativePlatform() && saml_request.value.saml_request) {
          setSamlID(saml_request.value.saml_request.request_id)
        } else {
          //clear potential data
          for (const clearItem of clearQueue) {
            await clearItem()
          }
        }
      } else if (jwt.active) {
        //found an active token, log the rep in
        await setJWT(JSON.parse(jwt.token) as Token_JWT)
        store.user.isLoggedIn = true
      } else if (!jwt.active) {
        //found an inactive token
        // but browser might have saml_request in storage
        if (!Capacitor.isNativePlatform() && saml_request.value.saml_request) {
          setSamlID(saml_request.value.saml_request.request_id)
        }
      }
      //browser will exchange request for token as a side effect of setting saml-id
    })
  } catch (error) {
    bootErrorMessage(error, { stage: 'authentication' })
  }
})
